import VuexTypes from '@/store/types/index';

const AuditLogsTypes = VuexTypes.auditLogs;
export default {
  [AuditLogsTypes.AUDIT_LOGS_LIST]: (state, { data, status }) => {
    state.auditLogsList = { data, status };
  },
  [AuditLogsTypes.AUDIT_LOGS_LIST_FILTERS]: (state, { data, status }) => {
    state.auditLogsListFilters = { data, status };
  },
};
